import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-71b864c6")

_pushScopeId("data-v-71b864c6")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "px-4" }
const _hoisted_3 = { class: "pa-4" }
const _hoisted_4 = { class: "actual-card-header" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 实时监测 ")
const _hoisted_6 = { class: "in-bed" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "realtime-title" }, [
  /*#__PURE__*/_createVNode("div", { class: "iconfont iconicon-heart mr-2" }),
  /*#__PURE__*/_createTextVNode(" 心率 ")
], -1)
const _hoisted_8 = { class: "circle" }
const _hoisted_9 = { class: "number" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "unit" }, "（BMP）", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "realtime-title" }, [
  /*#__PURE__*/_createVNode("div", { class: "iconfont iconreport-icon-huxi mr-2" }),
  /*#__PURE__*/_createTextVNode(" 呼吸率 ")
], -1)
const _hoisted_12 = { class: "circle back" }
const _hoisted_13 = { class: "number" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "unit" }, "（次/分）", -1)
const _hoisted_15 = { class: "actual-card-header" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 实时监测 ")
const _hoisted_17 = { class: "in-bed" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "realtime-title" }, [
  /*#__PURE__*/_createVNode("div", { class: "iconfont iconicon-heart mr-2" }),
  /*#__PURE__*/_createTextVNode(" 心率 ")
], -1)
const _hoisted_19 = { class: "circle" }
const _hoisted_20 = { class: "number" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "unit" }, "（BMP）", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "realtime-title" }, [
  /*#__PURE__*/_createVNode("div", { class: "iconfont iconreport-icon-huxi mr-2" }),
  /*#__PURE__*/_createTextVNode(" 呼吸率 ")
], -1)
const _hoisted_23 = { class: "circle back" }
const _hoisted_24 = { class: "number" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "unit" }, "（次/分）", -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 查看睡眠报告 ")
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-right" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_background_component = _resolveComponent("background-component")
  const _component_position_component = _resolveComponent("position-component")
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_background_component, {
        left: $setup.left,
        right: $setup.right
      }, null, 8, ["left", "right"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_position_component, {
        modelValue: $setup.position,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($setup.position = $event))
      }, null, 8, ["modelValue"]),
      ($setup.position === $setup.Position.LEFT)
        ? (_openBlock(), _createBlock(_component_my_card, {
            key: 0,
            class: "actual-card"
          }, {
            header: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", {
                    class: ["iconfont mr-2", [
                  $setup.left && $setup.left.bedStatus === $setup.BedStatus.ON
                    ? 'iconicon-zaichuang'
                    : 'iconicon-lichuang'
                ]]
                  }, null, 2),
                  _createVNode("div", null, _toDisplayString($setup.left && $setup.left.bedStatus === $setup.BedStatus.ON ? "在床" : "离床"), 1)
                ])
              ])
            ]),
            default: _withId(() => [
              _createVNode(_component_my_card_body, null, {
                default: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_7,
                    _createVNode("div", {
                      class: ["gif-content", [$setup.left && $setup.left.heart ? 'heart' : '']]
                    }, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode("div", _hoisted_9, _toDisplayString($setup.left && $setup.left.heart ? $setup.left.heart : "--"), 1),
                        _hoisted_10
                      ])
                    ], 2)
                  ]),
                  _hoisted_11,
                  _createVNode("div", {
                    class: ["gif-content", [$setup.left && $setup.left.breath ? 'breath' : '']]
                  }, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, _toDisplayString($setup.left && $setup.left.breath ? $setup.left.breath : "--"), 1),
                      _hoisted_14
                    ])
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_my_card, {
            key: 1,
            class: "actual-card"
          }, {
            header: _withId(() => [
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", {
                    class: ["iconfont mr-2", [
                  $setup.right && $setup.right.bedStatus === $setup.BedStatus.ON
                    ? 'iconicon-zaichuang'
                    : 'iconicon-lichuang'
                ]]
                  }, null, 2),
                  _createVNode("div", null, _toDisplayString($setup.right && $setup.right.bedStatus === $setup.BedStatus.ON ? "在床" : "离床"), 1)
                ])
              ])
            ]),
            default: _withId(() => [
              _createVNode(_component_my_card_body, null, {
                default: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_18,
                    _createVNode("div", {
                      class: ["gif-content", [$setup.right && $setup.right.heart ? 'heart' : '']]
                    }, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, _toDisplayString($setup.right && $setup.right.heart ? $setup.right.heart : "--"), 1),
                        _hoisted_21
                      ])
                    ], 2)
                  ]),
                  _hoisted_22,
                  _createVNode("div", {
                    class: ["gif-content ", [$setup.right && $setup.right.breath ? 'breath' : '']]
                  }, [
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, _toDisplayString($setup.right && $setup.right.breath ? $setup.right.breath : "--"), 1),
                      _hoisted_25
                    ])
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      ($setup.equipment)
        ? (_openBlock(), _createBlock(_component_my_card, {
            key: 2,
            class: "mt-4"
          }, {
            header: _withId(() => [
              _createVNode(_component_router_link, {
                to: `/report/day/${$setup.equipment.id}?temp=1`,
                class: "report-link"
              }, {
                default: _withId(() => [
                  _hoisted_26,
                  _hoisted_27
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
})